import { render, staticRenderFns } from "./BlockTagRow.vue?vue&type=template&id=23943f26&scoped=true&"
import script from "./BlockTagRow.vue?vue&type=script&lang=ts&"
export * from "./BlockTagRow.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTagRow.vue?vue&type=style&index=0&id=23943f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23943f26",
  null
  
)

export default component.exports